// extracted by mini-css-extract-plugin
export var brand = "_9i-9";
export var compact = "_9i-6";
export var extraSmall = "_9i-7";
export var icon = "_9i-0";
export var large = "_9i-4";
export var light = "_9i-1";
export var medium = "_9i-5";
export var outline = "_9i-b";
export var primaryDark = "_9i-a";
export var primaryLight = "_9i-8";
export var primaryModern = "_9i-c";
export var success = "_9i-2";
export var successSolid = "_9i-3";